export default (originalComponent) => {
    const JsxText = (props) =>
        originalComponent({
            ...props,
            transformers: ['jsx']
        });

    return JsxText;
};
